import ProgressBar from './progress-bar';
import './progress-bar.scss';

export default ProgressBar;
